import React, { useEffect, useState } from "react";
import { useUsersApi, useAuth } from "utils/hooks";
import isEqual from "lodash/isEqual";
import { useLocation } from "react-router-dom";

export const RbacContext = React.createContext(null);

/**
 * Provider component to wrap parts of the app that need access
 * to the group filter state.
 *
 * Persists the filter state in `localStorage` so it survives page reloads.
 * @memberof module:providers
 * @function
 * @name FilterProvider
 * @param {Object} props
 * @param {React.ReactNode} props.children - The components that consume this context.
 * @returns {JSX.Element} The provider wrapping the children.
 */
export const RbacProvider = ({ children }) => {
  const location = useLocation();
  const { isUserAuthorized, isUserAuthenticated, userId, selected_tenant_id, onRefreshToken } =
    useAuth();

  const api = useUsersApi();

  const [availableGroups, setAvailableGroups] = useState([]);

  const getUserProfile = async () => {
    try {
      const response = await api.getUserProfile(userId);
      // Sort tenants and their groups alphabetically
      const result = response.tenants
        .find((tenant) => tenant.tenantId === selected_tenant_id)
        // .groups.sort((a, b) => a.groupName.localeCompare(b.groupName));

      setAvailableGroups((prev) => {
        return isEqual(prev, result) ? prev : result;
      });

      return response;
    } catch (error) {
      // throw error;
    }
  };

  useEffect(() => {
    isUserAuthorized && onRefreshToken();
  }, [availableGroups]);

  useEffect(() => {
    isUserAuthenticated && !isUserAuthorized &&  onRefreshToken()
  }, [location]);

  return (
    <RbacContext.Provider
      value={{
        availableGroups,
        refreshUserProfile: getUserProfile, // optional helper
      }}
    >
      {children}
    </RbacContext.Provider>
  );
};
